import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import MyLocation from '@material-ui/icons/MyLocation';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    right: '10px',
    bottom: '10px',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  toggleButton: {
    background: 'white',
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      background: '#f5f5f5'
    }
  },
  coordinates: {
    fontSize: '12px',
    backgroundColor: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  active: {
    background: '#e3f2fd',
    borderColor: '#2196f3'
  }
}));

export default function CoordinateDisplay({ coordinates }) {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={classes.container}>
      <div 
        className={`${classes.toggleButton} ${isVisible ? classes.active : ''}`}
        onClick={() => setIsVisible(!isVisible)}
        title={isVisible ? "Skjul koordinater" : "Vis koordinater"}
      >
        <MyLocation 
          style={{ 
            fontSize: '20px',
            color: isVisible ? '#2196f3' : '#333'
          }}
        />
      </div>
      {isVisible && coordinates && (
        <span className={classes.coordinates}>{coordinates}</span>
      )}
    </div>
  );
}
